import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { auditor, AuditQueueTablesAPI } from 'App';

type AuditQueueUI = {
  totalResults: AuditQueueTablesAPI['totalResults'];
  examSessions: Array<
    Omit<
      AuditQueueTablesAPI['examSessions'][number],
      'userFirstName' | 'userLastName' | 'examSessionHandle'
    > & {
      studentName: string;
      uuid: string;
    }
  >;
  auditExamSessionList: Array<
    Omit<AuditQueueTablesAPI['auditExamSessionList'][number], 'auditUuid'> & {
      uuid: string;
    }
  >;
};

export function useAuditQueue(page: number): UseQueryResult<AuditQueueUI> {
  return useQuery(['audit queue', page], () => auditor.getAuditQueue(page), {
    select: ({ totalResults, examSessions, auditExamSessionList }) => ({
      totalResults,
      examSessions: examSessions.map((session) => ({
        partnerName: session.partnerName,
        courseName: session.courseName,
        examName: session.examName,
        studentName: `${session.userFirstName} ${session.userLastName}`,
        examStartTime: session.examStartTime,
        examEndTime: session.examEndTime,
        examDuration: session.examDuration,
        uuid: session.examSessionHandle,
        specialPartner: session.specialPartner,
      })),
      auditExamSessionList: auditExamSessionList.map(({ auditUuid, ...session }) => ({
        ...session,
        uuid: auditUuid,
      })),
    }),
    staleTime: undefined,
  });
}
